import React, { useEffect } from 'react';
import locales from '../../../content.json';

import bgAvif from './img/bg.avif';
import bgPng from './img/bg.png';

import { analyticsEventsTracker, GTMOnboardingFunnelEvent, EVENT_TRACKERS } from '../../../utils/analytics';
import s from './index.module.scss';
import { getParameterFromURL } from '../../../utils/scripts';
import icn from './img/icn.png';

export const MainScreenNutrition = () => {
  const subscrUK = getParameterFromURL('subscrUK');
  const version = subscrUK ? 'version2UK' : 'version2';

  useEffect(() => {
    analyticsEventsTracker.trackWithTarget(GTMOnboardingFunnelEvent.showPaywall(version), EVENT_TRACKERS.GTM);
  }, []);

  return (
    <div className={s.mainScreen}>
      <h2 className={s.title}>{locales[window.userLang].payment_text_338}</h2>
        <p
          className={s.subtitle}
          dangerouslySetInnerHTML={{
            __html: locales[window.userLang].payment_text_339,
          }}
        />
      <div className={s.imgWrapper}>
        <img className={s.label} src={icn} alt="icn" />
        <picture>
          <source srcSet={bgAvif} type="image/avif" />
          <img className={s.image} src={bgPng} alt="header image" />
        </picture>
      </div>
    </div>
  );
};
